import React from "react";
import { classNames } from "@servicestack/client";
import { styled, keyframes } from "@mui/material/styles";

interface IInlineLoadingProps {
    size?: number;
    text?: string;
    textAnchor?: "Left" | "Right" | "Top" | "Bottom";
    className?: string;
    absoluteCenter?: boolean;
}

const loadingKeyframes = keyframes`
    0% { transform: scale(1); }
    20% { transform: scale(1, 2.2); }
    40% { transform: scale(1); }
`;

const Root = styled("div")<{
    size?: number;
    absoluteCenter?: boolean;
}>(({ theme, size = 30, absoluteCenter }) => {
    const actualSize = size;
    const baseHeight = actualSize / 2.2;
    const baseWidth = actualSize / 7.0;

    return {
        position: "relative",
        ...(absoluteCenter && {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
        }),
        "& .loading": {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "space-between",
            height: baseHeight,
            width: actualSize,
            "& .loading-bar": {
                display: "inline-block",
                width: baseWidth,
                height: baseHeight,
                borderRadius: 4,
                animation: `${loadingKeyframes} 1s ease-in-out infinite`,
                "&:nth-of-type(1)": {
                    animationDelay: "0s",
                    backgroundColor: theme.palette.primary.main,
                },
                "&:nth-of-type(2)": {
                    animationDelay: "0.09s",
                    backgroundColor: theme.palette.secondary.main,
                },
                "&:nth-of-type(3)": {
                    animationDelay: "0.18s",
                    backgroundColor: theme.palette.primary.main,
                },
                "&:nth-of-type(4)": {
                    animationDelay: "0.27s",
                    backgroundColor: theme.palette.secondary.main,
                },
            },
        },
    };
});

class InlineLoading extends React.Component<IInlineLoadingProps, unknown> {
    render() {
        const { size, className, absoluteCenter } = this.props;

        const actualSize = size ? size : 30;
        const baseHeight = actualSize / 2.2;
        const baseWidth = actualSize / 7.0;

        return (
            <Root
                className={classNames("color-bar-loading", className)}
                size={actualSize}
                absoluteCenter={absoluteCenter}
                style={{ height: actualSize, width: actualSize }}
            >
                <div className="loading" style={{ height: baseHeight, width: actualSize }}>
                    <div className="loading-bar" style={{ height: baseHeight, width: baseWidth }} />
                    <div className="loading-bar" style={{ height: baseHeight, width: baseWidth }} />
                    <div className="loading-bar" style={{ height: baseHeight, width: baseWidth }} />
                    <div className="loading-bar" style={{ height: baseHeight, width: baseWidth }} />
                </div>
            </Root>
        );
    }
}

export default InlineLoading;
